const SCHEDULE_DEFAULT_VALUES = {
  scheduleStart: '08:00:00',
  scheduleEnd: '17:00:00',
  timeZone: null,
};

export { SCHEDULE_DEFAULT_VALUES };
